import { render, staticRenderFns } from "./StandardsHomeSatchel.vue?vue&type=template&id=4a537dfc"
import script from "./StandardsHomeSatchel.vue?vue&type=script&lang=js"
export * from "./StandardsHomeSatchel.vue?vue&type=script&lang=js"
import style0 from "./StandardsHomeSatchel.vue?vue&type=style&index=0&id=4a537dfc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports